import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
    title: string;
    icon: React.ReactNode;
    onClick: () => void;
}

const MobileHeaderButton = (props: Props) => {
    const { t } = useTranslation();
    const styledIcon = React.cloneElement(props.icon as any, {
        className: "flex justify-center items-center w-full h-full", // or any additional props you want to pass
        style: { fontSize: "34px" }
    });
    return (
        <div onClick={props.onClick} className="flex gap-1 bg-primary rounded-[8px] py-[8px] px-[4px]">
            <div className="px-2">
                {styledIcon}
            </div>
            <div className="font-bold text-[18px] flex  items-center w-full h-full">
                {props.title}
            </div>
        </div>
    )
}

export default MobileHeaderButton